import { render, staticRenderFns } from "./form-restart-schedule.component.vue?vue&type=template&id=83831018&scoped=true&"
import script from "./form-restart-schedule.component.vue?vue&type=script&lang=ts&"
export * from "./form-restart-schedule.component.vue?vue&type=script&lang=ts&"
import style0 from "./form-restart-schedule.component.vue?vue&type=style&index=0&id=83831018&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83831018",
  null
  
)

export default component.exports